/** API service (using axios HTTP client) */
import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_QUESTIONS_API_URL,
});

/** Question data presented as json file */
const QUESTION_ENDPOINT = 'questions.json';

export default {
    getQuestions(success, failure) {
        api.get(QUESTION_ENDPOINT)
            .then(function (response) {
                success(response.data);
            })
            .catch(function (error) {
                failure(error.toString());
            })
    }
}